import styled from "styled-components";



 export const StyledNavbar = styled.nav`
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
   background-color: ${({ bColor }) => bColor};
   line-height: 1.5;
   padding: 10px 10px;
   min-width: 100vw;
   & > p {
     margin-right: 5px;
   }
   & > div {
     display: none;
   }
   & button {
     display: flex;
   }
   @media screen and (min-width:500px) {
     & button {
       display: none;
     }
     & > div {
       display: flex;
       width: 50%;
       justify-content: space-around;
       & a:hover {
         border-bottom: 1px solid #725cff;
       }
     }
     border-color: 1px solid red;
   }
 `;   
